import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import log from "loglevel";
import { Button, Modal } from "react-bootstrap";
import Select from "react-select";
import { generateTeamDropdownItems } from "util/dashboardUtil";
import {
  addAnalysisTeamAction,
  deleteAnalysisTeamAction
} from "store/actions/actionCreators";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import {
  Analysis,
  Team,
  AnalysisTeam,
  AddAnalysisTeamRequestType,
  DeleteAnalysisTeamRequestType
} from "types";
import AnalysisTeamsTable from "components/dashboard/analysis/AnalysisTeamsTable";
import genStyles from "styles/General.module.scss";

type GrantAnalysisTeamPermissionFormType = {
  team_id: number | undefined;
};

type RevokeAnalysisTeamPermissionFormType = {
  analysis_team_id: number | undefined;
};

const AccountAnalysisPermissionModal = ({
  analysis,
  accountTeams,
  analysisPermittedTeams
}: {
  analysis: Analysis;
  accountTeams: Team[];
  analysisPermittedTeams: AnalysisTeam[];
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [grantTeam, setGrantTeam] = useState<
    GrantAnalysisTeamPermissionFormType
  >();
  const [revokeTeam, setRevokeTeam] = useState<
    RevokeAnalysisTeamPermissionFormType
  >();
  const [selectedTeam, setSelectedTeam] = useState<Team>();
  const [isGrantingPermission, setIsGrantingPermission] = useState<boolean>(
    false
  );
  const [isRevokingPermission, setIsRevokingPermission] = useState<boolean>(
    false
  );

  const onHandleAddTeamToAnalysisClick = (event: any) => {
    event.preventDefault();
    log.info("Attempting to GRANT permissions for TEAM to ANALYSIS ...");
    if (grantTeam?.team_id) {
      const request: AddAnalysisTeamRequestType = {
        analysis_id: analysis.id,
        account_name: analysis.account_name, // necessary for GET in saga
        analysis_name: analysis.name, // necessary for GET in saga
        body: {
          team_id: grantTeam.team_id
        }
      };
      log.info("-- Dispatching addAnalysisTeamAction()...");
      dispatch(addAnalysisTeamAction(request));
      setIsGrantingPermission(false);
    } else {
      log.info("One or more fields NOT VALID!");
      log.info("AddAnalysisTeamRequestType %o: ", grantTeam);
    }
  };

  const onHandleDeleteTeamFromAnalysisClick = (analysisTeamId: number) => {
    log.info("Attempting to Revoke permissions from TEAM to ANALYSIS ...");
    if (analysisTeamId) {
      setIsRevokingPermission(true);
      const request: DeleteAnalysisTeamRequestType = {
        id: analysisTeamId,
        account_name: analysis.account_name, // necessary for GET in saga
        analysis_name: analysis.name // necessary for GET in saga
      };
      log.info("-- Dispatching deleteAnalysisTeamAction()...");
      dispatch(deleteAnalysisTeamAction(request));
    } else {
      log.info("One or more fields NOT VALID!");
      log.info("DeleteAnalysisTeamRequestType %o: ", revokeTeam);
    }
  };

  const onSelectTeamFromDropdown = (teamItem: any) => {
    if (teamItem) {
      log.info("Select Team: Team Dropdown Item, Selected! : %o", teamItem);
      setGrantTeam({ team_id: teamItem.id });
      setSelectedTeam(teamItem.team);
    }
  };

  return (
    <Modal.Body>
      <form name="modify-form">
        <AnalysisTeamsTable
          analysisTeams={analysisPermittedTeams}
          trashCellCallback={onHandleDeleteTeamFromAnalysisClick}
          rowEvents={null}
          showAccount={false}
          cardTable={true}
        />
        <Select
          options={generateTeamDropdownItems(accountTeams)}
          placeholder={"Select Team..."}
          isClearable={false}
          onChange={onSelectTeamFromDropdown}
        />
        <button
          type="submit"
          className={[
            genStyles["alenza__btn-create__mini"],
            "float-right"
          ].join(" ")}
          disabled={!selectedTeam}
          onClick={(e: any) => {
            setIsGrantingPermission(true);
            onHandleAddTeamToAnalysisClick(e);
          }}
        >
          {selectedTeam?.name
            ? `Add ${selectedTeam?.name} to ${analysis.name}`
            : "Select a Team from above"}
        </button>
      </form>
    </Modal.Body>
  );
};

export default AccountAnalysisPermissionModal;
